import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4781b8ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-h5 text-uppercase font-weight-bold" }, "Fatura", -1))
const _hoisted_2 = { class: "d-flex flex-column font-weight-thin mb-10" }
const _hoisted_3 = { class: "text-uppercase" }
const _hoisted_4 = {
  style: {"width":"100%"},
  class: "my-10"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "font-weight-bold text-uppercase" }, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"25%"} }, "Data"),
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"25%"} }, "Fatura nº"),
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"50%"} }, "Cliente")
], -1))
const _hoisted_6 = { class: "font-weight-thin" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "text-uppercase" }
const _hoisted_9 = { style: {"width":"100%","border-collapse":"collapse"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "font-weight-bold text-uppercase" }, [
  /*#__PURE__*/_createElementVNode("td", { style: {"border-bottom":"1px solid rgba(255, 0, 0, .2)"} }, "Descrição"),
  /*#__PURE__*/_createElementVNode("td", { style: {"border-bottom":"1px solid rgba(255, 0, 0, .2)"} }, "Subtotal")
], -1))
const _hoisted_11 = {
  style: {"width":"75%"},
  class: "py-3"
}
const _hoisted_12 = {
  style: {"width":"25%"},
  class: "py-3 text-red font-weight-bold"
}
const _hoisted_13 = {
  class: "mt-10",
  style: {"width":"100%","border-collapse":"collapse"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "font-weight-bold text-uppercase" }, [
  /*#__PURE__*/_createElementVNode("td", { style: {"border-bottom":"1px solid rgba(255, 0, 0, .1)"} }, "Banco"),
  /*#__PURE__*/_createElementVNode("td", { style: {"border-bottom":"1px solid rgba(255, 0, 0, .1)"} }, "Ag / Conta"),
  /*#__PURE__*/_createElementVNode("td", { style: {"border-bottom":"1px solid rgba(255, 0, 0, .1)"} }, "Vencimento"),
  /*#__PURE__*/_createElementVNode("td", { style: {"border-bottom":"1px solid rgba(255, 0, 0, .1)"} }, "Total")
], -1))
const _hoisted_15 = { class: "font-weight-thin" }
const _hoisted_16 = { class: "py-3" }
const _hoisted_17 = { class: "py-3" }
const _hoisted_18 = { class: "py-3" }
const _hoisted_19 = { class: "py-3 text-red text-subtitle-2 font-weight-bold" }
const _hoisted_20 = { class: "d-flex flex-column font-weight-bold text-uppercase mt-10" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "QR CODE", -1))

import { API_URL_BASE } from '@/env';
import { computed, inject, ref, onMounted } from 'vue';
import tokenRepository from '@/app/shared/infrastructure/persistence/token-repository';
import BillingRepository from '../../infrastructure/persistence/BillingRepository';
import CompanyRepository from '@/app/my-company/infrastructure/persistence/CompanyRepository';
import Money from '@/app/shared/domain/classes/money';
import Billing from '../../domain/interfaces/Billing';
import MyCompany from '@/app/my-company/domain/interfaces/MyCompany';
import Client from '@/app/client/domain/interfaces/Client';
import ClientRepository from '@/app/client/infrastructure/persistence/ClientRepository';
import banks from '@/app/shared/domain/data/banks';


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingCover',
  props: ['id'],
  setup(__props) {

const props = __props;

const token = tokenRepository().get();

const billingRepository = inject('billingRepository') as BillingRepository;
const companyRepository = inject('companyRepository') as CompanyRepository;
const clientRepository = inject('clientRepository') as ClientRepository;
const billing = ref({} as Billing);
const company = ref({} as MyCompany);
const client = ref({} as Client);
const billingTotal = ref('');

const qrcodePath = computed(() => {
    return `${API_URL_BASE}/assets/images--qrcodes--${company.value.qrcode}/${token}`;
});

const account = computed(() => {
    if (company.value.account_list) {
        const currentCompany = company.value.account_list[0];
        return {
            ...currentCompany,
            bank_name: banks.find(bank => bank.value == currentCompany.code_bank)?.title
        };
    }
    return {} as any;
});

onMounted(async () => {
    billingRepository.getById(props.id).then(result => {
        billing.value = result;
        billingTotal.value = new Money(result.total).toStringBR();

        clientRepository.getById(result.client_id).then(result => {
            client.value = result;
        });
    });

    companyRepository.get().then(result => {
        company.value = result;
    });

    setTimeout(() => {
        window.print();
    }, 3000);
});

function getMoneyValue(value: string): string {
    return new Money(Number(value)).toStringBR();
}


return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "py-15" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        theme: "lightTheme",
        style: {"font-size":"0.65rem"},
        class: "elevation-0"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_v_img, {
            class: "my-5",
            src: "/images/logo.png",
            height: "80",
            width: "80"
          }),
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(company.value.document?.type) + ": " + _toDisplayString(company.value.document?.value), 1),
            _createElementVNode("span", null, _toDisplayString(company.value.address?.street) + " , " + _toDisplayString(company.value.address?.number) + " - " + _toDisplayString(company.value.address?.complement) + " - " + _toDisplayString(company.value.address?.neighborhood) + " - " + _toDisplayString(company.value.address?.city) + " / " + _toDisplayString(company.value.address?.state), 1),
            _createElementVNode("span", null, _toDisplayString(company.value.email), 1),
            _createElementVNode("span", null, _toDisplayString(company.value.phone), 1)
          ]),
          _createElementVNode("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tr", _hoisted_6, [
              _createElementVNode("td", null, _toDisplayString(billing.value.due_date), 1),
              _createElementVNode("td", null, _toDisplayString(billing.value.id), 1),
              _createElementVNode("td", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(client.value.name), 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(client.value.document?.type) + ": " + _toDisplayString(client.value.document?.value), 1),
                _createElementVNode("span", null, _toDisplayString(client.value.address?.street) + ", " + _toDisplayString(client.value.address?.number) + " - " + _toDisplayString(client.value.address?.city) + " / " + _toDisplayString(client.value.address?.state), 1),
                _createElementVNode("span", null, _toDisplayString(client.value.email), 1),
                _createElementVNode("span", null, _toDisplayString(client.value.phone), 1)
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(billing.value.items, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "font-weight-thin",
                key: index
              }, [
                _createElementVNode("td", _hoisted_11, _toDisplayString(item.description), 1),
                _createElementVNode("td", _hoisted_12, "R$ " + _toDisplayString(getMoneyValue(item.value)), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("table", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("tr", _hoisted_15, [
              _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(account).code_bank) + " - " + _toDisplayString(_unref(account).bank_name), 1),
              _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(account).agency) + " / " + _toDisplayString(_unref(account).number), 1),
              _createElementVNode("td", _hoisted_18, _toDisplayString(billing.value.due_date), 1),
              _createElementVNode("td", _hoisted_19, "R$ " + _toDisplayString(billingTotal.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_v_img, {
              src: _unref(qrcodePath),
              height: "200",
              width: "200"
            }, null, 8, ["src"]),
            _createElementVNode("span", null, "Chave pix: " + _toDisplayString(_unref(account).pix_key), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})